import { createSelector } from 'reselect';
import { get, map, values } from 'lodash/fp';

function getBonuses(bonuses, bonusesChosen) {
  return map(
    item => ({
      ...item,
      selected: !!bonusesChosen[item.id]
    }),
    values(bonuses)
  );
}

const bonusesSelector = createSelector(
  get('challenge.bonuses'),
  get('lineUp.bonusesChosen'),
  getBonuses
);

export default bonusesSelector;
